module.exports = __webpack_public_path__ + "img/home_img3.68bd97f6.png";